/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'
import { Button, Modal } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import SpotifyIcon from 'mdi-react/SpotifyIcon'

import StatsImage from 'Shared/img/stats.svg'
import { APP } from 'Configs/App'

const ModalComponent = ({ toggle, modal }) => {
  const { t } = useTranslation()

  const handleSubmit = () => {
    localStorage.clear()
    window.location.href = APP.SPOTIFY_AUTH_API
  }

  return (
    <div>
      <Modal
        fade={false}
        backdrop="static"
        className="modal-dialog--danger modal-dialog--header"
        isOpen={modal}
        modalClassName="ltr-support"
        toggle={toggle}
      >
        <div className="modal__header">
          <h4 className="text-modal  modal__title">{t('connect.connect')}</h4>
        </div>
        <div style={{ margin: '30px', textAlign: 'center' }}>
          <span className="stats-image">
            <img
              src={StatsImage}
              alt="statsImage"
              style={{ height: '200px' }}
            />
          </span>
          <p>{t('connect.itSeems')}</p>
          <p>{t('connect.reconnect')}</p>
          <br />
          <Button
            color="success"
            style={{ margin: '0 auto' }}
            onClick={handleSubmit}
          >
            <SpotifyIcon />
            {t('connect.connectAgain')}
          </Button>
        </div>
      </Modal>
    </div>
  )
}

export default ModalComponent
